/* eslint-disable react/jsx-no-duplicate-props */
import React from "react";
import { withTranslation } from "react-i18next";
import { OutlineSecondaryButton } from "../assets/static/js/Button";
import CurrencyFormat from "react-currency-format";

class ProductCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;
    return (
      <div className="item-card">
        {this.props.isNew && (
          <div className="triangle-container">
            <div style={{ borderBottomColor: "#00C773"}} className="triangle"></div>
            <div className="triangle-container_text">New</div>
          </div>
        )}
        {this.props.isTrend && (
          <div className="triangle-container">
            <div style={{ borderBottomColor: "#FF8900"}} className="triangle"></div>
            <div className="triangle-container_text">Hit</div>
          </div>
        )}
        {this.props.isDiscount > 0 && (
          <div className="triangle-container">
            <div style={{ borderBottomColor: "#F00"}} className="triangle"></div>
            <div className="triangle-container_text">Sale</div>
          </div>
        )}
        <div style={{ maxHeight: "372px", overflow: "hidden" }}>
          <img src={this.props.image} alt={this.props.catName ? this.props.catName + this.props.name + " " + this.props.index  :  this.props.name + " " + this.props.index } />
        </div>
        <div className="bottom-infos d-flex flex-column">
          <div className="small-infos d-flex flex-column">
            <h1 className="text-xs">{this.props.articul}</h1>
            <h1 className="text-lg"> {this.props.name} </h1>
            {this.props.models} {this.props.models ? t("models.text") : ""}
          </div>
          <div className="price-infos mt-1 d-flex flex-wrap">
            <div className="mb-3 d-flex flex-gap-5">
              {this.props.isDiscount > 0 && !this.props.styles && (
                <span className="text-sm text-through mr-2 text-nowrap" style={{ fontSize: "12px" }}>
                  <CurrencyFormat
                    value={this.props.price}
                    displayType={"text"}
                    thousandSeparator=" "
                    suffix={t("suffix.text")}
                  /> за м<sup>2</sup>
                </span>
              )}

              <br />
              {!this.props.styles && (
                <span className="text-sm bold text-nowrap">
                  <CurrencyFormat
                    value={this.props.price - this.props.isDiscount}
                    displayType={"text"}
                    thousandSeparator=" "
                    suffix={t("suffix.text")}
                  />/м<sup>2</sup>
                </span>
              )}
            </div>
            {/* <div style={this.props.styles && { width: "100%" }} className="button-wrapper">
              <OutlineSecondaryButton style={this.props.styles && { width: "100%" }} value={t("more.text")} />
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(ProductCard);
